import type { CompositionPanelAppearance } from './model';

export const LEGACY_SCALE_BAR_PANEL: CompositionPanelAppearance = {
  background: { enabled: false, colour: '#ffffff', opacity: 50 },
  border: { enabled: false, colour: '#52606d', widthMm: 0.25 },
  cornerRadiusMm: 0,
  paddingMm: 0,
};

/** Shared physical scale-bar content box for DOM, Canvas and PDF. Position anchors its outer box. */
export function scaleBarLayout(
  width: number,
  fontSize: number,
  thickness: number,
  panel: CompositionPanelAppearance | undefined,
  unitsPerMm: number,
  segmented: boolean,
  above = false,
) {
  const padding = (panel?.paddingMm ?? 0) * unitsPerMm;
  const border = panel?.border.enabled ? panel.border.widthMm * unitsPerMm : 0;
  const inset = padding + border;
  const barHeight = segmented
    ? Math.max(fontSize * 0.48, thickness * 2)
    : fontSize * 0.48 + thickness;
  return {
    inset,
    width: width + inset * 2,
    height: inset * 2 + barHeight + fontSize * (0.28 + 1.15),
    barHeight,
    barY: inset + (above ? fontSize * 1.43 : 0),
    labelY: above ? inset : inset + barHeight + fontSize * 0.28,
    radius: Math.min(
      (panel?.cornerRadiusMm ?? 0) * unitsPerMm,
      (width + inset * 2) / 2,
      (inset * 2 + barHeight + fontSize * 1.43) / 2,
    ),
    border,
  };
}
